export default __webpack_public_path__ + "static/media/Multi-Select.e7c51dbc.gif";